module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[90]577.0420b69.woff2";